module.exports = {"150602001":"交通街道","150602002":"公园街道","150602003":"林荫街道","150602004":"建设街道","150602005":"富兴街道","150602006":"天骄街道","150602007":"诃额伦街道","150602008":"巴音门克街道","150602010":"幸福街道","150602011":"纺织街道","150602012":"兴盛街道","150602013":"民族街道","150602100":"泊尔江海子镇","150602101":"罕台镇","150602102":"铜川镇","150602400":"鄂尔多斯市装备制造基地","150602401":"东胜区轻纺工业园区","150602404":"铜川汽车博览园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150602.json
// module id = 390
// module chunks = 0